<app-ecom-header></app-ecom-header>
<div class="col-12 mt-6 headings p-0 background-grey pl-2">
    <div class="row p-3">
        <div class="faicon col-1"><i class="fab fa-teamspeak fa-lg" style="color: #339af0;" aria-hidden="true"></i></div>
        <div class="col cursor-pointer">
            <span for="" class="text-dark font-weight-bold h6">Support</span>
        </div>
    </div>
</div>
<div class="col-12 mt-6 headings p-0 pl-4 pr-4">
    <div class="row p-2 mt-3">
        <div class="faicon col-1"><i class="fa fa-phone fa-lg" aria-hidden="true"></i></div>
        <div class="col cursor-pointer" (click)="onCallClick()">
            <span for="" class="text-dark">Call 1800-22-1333</span>
        </div>
    </div>
    <hr class="color-white px-1">
    <div class="row p-2">
        <div class="faicon col-1"><i class="far fa-comments fa-lg" aria-hidden="true"></i></div>
        <div class="col cursor-pointer" (click)="onChatStartClick()">Start a Chat</div>
    </div>
    <hr class="color-white px-1">
    <div class="row p-2">
        <div class="faicon col-1"><i class="fa fa-file fa-lg" aria-hidden="true"></i></div>
        <div class="col cursor-pointer">View Terms of Use and Privacy Policy</div>
    </div>
    <hr class="color-white px-2">
</div>
